"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _TopBar = _interopRequireDefault(require("../01_atoms/TopBar"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PopupField = function PopupField(_ref) {
  var title = _ref.title,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      children = _ref.children,
      field = _ref.field,
      _ref$topBarChildren = _ref.topBarChildren,
      topBarChildren = _ref$topBarChildren === void 0 ? null : _ref$topBarChildren;
  var style = {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 999999,
    width: '100vw'
  };

  if (hidden) {
    Object.assign(style, {
      display: 'none'
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_Page["default"], {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_TopBar["default"], {
    title: title,
    leftIcon: "close",
    onLeftIconClick: onBack
  }, topBarChildren), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: 999999
    }
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, field)), children));
};

var _default = PopupField;
exports["default"] = _default;